import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const StyledMatrixForDownloadContainer = styled.div`
  position: absolute;
  left: -9999px;
  top: -9999px;
  box-sizing: content-box;
`;

export const StyledMatrixForDownloadContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  height: 100%;
`;

export const StyledMatrixForDownloadHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StyledMatrixForDownloadTitle = styled.span`
  font-size: 48px;
  font-weight: 500;
  font-family: ${theme.variables.font_family};
`;

export const StyledMatrixForDownloadSubtitle = styled.span`
  font-size: 36px;
  font-weight: 500;
  font-family: ${theme.variables.font_family};
  white-space: pre-line;
`;
